
document.addEventListener("DOMContentLoaded", function () {
  const stickyAdd = document.querySelector(".cstm-stcky-add");
  if (!stickyAdd) return;

  function handleStickyAdd() {

    // Mobile only
    if (window.innerWidth <= 768) {

      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;

      if (scrollPercent >= 18) {
        stickyAdd.style.display = "block";
      } else {
        stickyAdd.style.display = "none";
      }

    } else {
      // Desktop par always show
      stickyAdd.style.display = "block";
    }
  }

  // run on load
  handleStickyAdd();

  // run on scroll and resize
  window.addEventListener("scroll", handleStickyAdd);
  window.addEventListener("resize", handleStickyAdd);

});